
const dropdowns = [...document.querySelectorAll('.js-dropdown')]

dropdowns.forEach(function applyKeyboardOperation (dropdown) {
    const trigger = dropdown.querySelector('.js-dropdownTrigger')
    const container = dropdown.querySelector('.js-dropdownContainer')
    const focusables = [...container.querySelectorAll('[tabindex]')]
    const clickOnly = trigger.dataset.clickonly * 1

    if (!clickOnly) {
        dropdown.addEventListener('mouseover', () => {
            dropdowns.forEach(dropdownItem =>
                [...dropdownItem.classList].indexOf('-noHover') === -1
                    ? dropdownItem.classList.remove('-open')
                    : null
            )
        })

        trigger.addEventListener('keydown', e => {
            if (
                (e.key === 'Enter' || e.key === ' ') &&
                !(trigger.dataset.open * 1) &&
                window.innerWidth > 991
            ) {
                e.preventDefault()

                focusables.forEach(focusable => {
                    focusable.tabIndex = '0'
                })
                dropdown.classList.add('-open')

                trigger.dataset.open = 1
            }
        })
    }

    if (clickOnly) {
        const icon = trigger.querySelector('.js-buttonIcon')

        const [firstFocusable] = focusables

        trigger.addEventListener('click', e => {
            e.preventDefault()

            if (trigger.dataset.open * 1) {
                focusables.forEach(focusable => {
                    focusable.tabIndex = '-1'
                })

                dropdown.classList.remove('-open')
                icon.classList.remove('fal', 'fa-times')
                icon.classList.add('fas')

                trigger.dataset.open = 0

                trigger.focus()
            } else {
                focusables.forEach(focusable => {
                    focusable.tabIndex = '0'
                })
                dropdown.classList.add('-open')
                icon.classList.remove('fas')
                icon.classList.add('fal', 'fa-times')

                trigger.dataset.open = 1
            }
        })

        container.addEventListener('focusout', e => {
            if (!container.contains(e.relatedTarget)) {
                focusables.forEach(focusable => {
                    focusable.tabIndex = '-1'
                })
                dropdown.classList.remove('-open')
                icon.classList.remove('fal', 'fa-times')
                icon.classList.add('fas')

                trigger.dataset.open = 0
            }
        })

        trigger.addEventListener('keydown', e => {
            if (
                (e.key === 'Enter' || e.key === ' ') &&
                !(trigger.dataset.open * 1) &&
                window.innerWidth > 991
            ) {
                e.preventDefault()

                focusables.forEach(focusable => {
                    focusable.tabIndex = '0'
                })
                dropdown.classList.add('-open')
                icon.classList.remove('fas')
                icon.classList.add('fal', 'fa-times')

                firstFocusable.focus()

                trigger.dataset.open = 1
            }
        })
    }

    if (!clickOnly) {
        container.addEventListener('focusout', e => {
            if (!container.contains(e.relatedTarget)) {
                focusables.forEach(focusable => {
                    focusable.tabIndex = '-1'
                })
                dropdown.classList.remove('-open')
                trigger.dataset.open = 0
            }
        })
    }

    dropdown.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            focusables.forEach(focusable => {
                focusable.tabIndex = '-1'
            })
            dropdown.classList.remove('-open')
            trigger.dataset.open = 0

            trigger.focus()
        }
    })
})
